import { Link } from 'react-router-dom';
import styles from './NotFoundPage.module.css';
import { Seo } from '../components/Seo';

// 404 — catch-all 라우트('*')가 렌더한다. 동적 catch-all 은 프리렌더 제외되므로
// dist/404.html 은 생성되지 않는다. nginx 의 SPA fallback(/index.html)을 타고
// 클라이언트 사이드에서 이 페이지가 그려진다(인프라 변경 0).
// noindex 라 sitemap 에도 포함되지 않는다.
export function NotFoundPage() {
  return (
    <main className={styles.main}>
      <Seo
        noindex
        title="페이지를 찾을 수 없습니다 — medilawyer"
        description="요청하신 페이지를 찾을 수 없습니다. 주소가 변경되었거나 삭제되었을 수 있습니다."
        path="/404"
      />
      <div className={styles.box}>
        <span className={styles.code}>404</span>
        <span className={styles.eyebrow}>Page Not Found</span>
        <h1 className={styles.title}>페이지를 찾을 수 없습니다</h1>
        <p className={styles.desc}>
          요청하신 페이지를 찾을 수 없습니다. 주소가 변경되었거나 삭제되었을 수 있어요. 아래
          버튼으로 다시 이동해 주세요.
        </p>
        <div className={styles.actions}>
          <Link to="/" className={styles.primary}>
            홈으로 돌아가기
          </Link>
          <Link to="/contract" className={styles.secondary}>
            계약 안내 보기
          </Link>
        </div>
      </div>
    </main>
  );
}
